// Styles
import 'flickity/css/flickity.css';
import '../scss/style.scss';

// JS deps
import $ from 'jquery';
import ready, { HTML } from './utils';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import resize from '@alpinejs/resize';

// Our components
import initFilterableBlocks from './components/filterableBlocks';
import BookingBox from './components/bookingbox';
import './components/livesearch';
// import './components/tools'; // new site header
import './components/carousel';
import './components/slider';
import './plugins/jquery.fitvids';
import './components/landingPageTracking';

ready(() => {
  HTML.classList.add('is-loaded');
  initFilterableBlocks();
  const bb = new BookingBox('#booking');
  $('.has-video').fitVids();
});

window.Alpine = Alpine;

Alpine.plugin(resize);
Alpine.plugin(collapse);

Alpine.start();
